import React from 'react';
import * as S from './styles';

export type TitleFormProps = {
	children: React.ReactNode;
	title: string;
};

export default function TitleForm({ children, title }: TitleFormProps) {
	return (
		<S.container>
			<h1>{title}</h1>
			{children}
			<S.line />
		</S.container>
	);
}
